import { FadeText, AnimatedLine } from 'components/CustomAnimations';
import OrbsContainer from 'components/LottieElements/OrbsContainer';

export const OurWhy = () => {
  return (
    <OrbsContainer jsonType="hero_module">
      <div className="our-why-container">
        <div className="our-why-title">
          <FadeText
            progressive
            className="h1-dtm white"
            text="Oath is the one-stop-shop for political giving that helps you maximize your impact."
          />
        </div>
        <div className="our-why-description">
          <div className="our-why-container">
            <AnimatedLine delay={1.5} />
            <FadeText className="eyebrow-text" text="Our why" delay={3} />
            <FadeText className="h3-dtm" text="Political fundraising is broken." delay={3} />
            <FadeText
              className="h4-text"
              text="Every cycle, donors waste millions of dollars giving to long-shot races, safe seats,
                  or donating too late to make a difference."
              delay={3}
            />
            <FadeText className="h4-text" text="We’re here to change that." delay={3} />
          </div>
        </div>
      </div>
    </OrbsContainer>
  );
};
